/**
 * Created by Administrador on 24/05/2016.
 */
(function(){
    'use strict';

    angular.module('distanceSegment', [])
        .directive('distance', ['stretchService', autoCompleteSegment]);

    function autoCompleteSegment(stretchService){
        var directive = {
            restrict: 'AC',
            require: 'ngModel',
            link: linkFunc
        }
        return directive;

        function linkFunc(scope, element, attrs, ngModel){
            stretchService.getStretch(attrs.origin,attrs.destiny)
                .then(function(res){
                    if(res != undefined){
                        ngModel.$setViewValue(res.data.distance);
                        ngModel.$render();
                    }
                });
        }
    }

})();
